/**
 * Utilidad para manejar la zona horaria de Colombia
 * Todas las fechas y horas del sistema deben usar estas funciones
 */

/**
 * Obtiene la fecha/hora actual de Colombia
 * @returns {Date} Fecha con hora de Colombia
 */
export const getNowColombia = () => {
  // Crear fecha actual en UTC
  const now = new Date();
  
  // Convertir a hora de Colombia (UTC-5)
  const colombiaTime = new Date(now.toLocaleString('en-US', {
    timeZone: 'America/Bogota'
  }));
  
  return colombiaTime;
};

/**
 * Formatea una fecha en formato YYYY-MM-DD (Colombia)
 * @param {Date} date - Fecha a formatear (opcional, por defecto usa hora actual de Colombia)
 * @returns {string} Fecha en formato YYYY-MM-DD
 */
export const getFechaColombia = (date = null) => {
  const colombiaDate = date || getNowColombia();
  
  const year = colombiaDate.getFullYear();
  const month = String(colombiaDate.getMonth() + 1).padStart(2, '0');
  const day = String(colombiaDate.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
};

/**
 * Formatea una hora en formato HH:MM (Colombia)
 * @param {Date} date - Fecha a formatear (opcional, por defecto usa hora actual de Colombia)
 * @returns {string} Hora en formato HH:MM
 */
export const getHoraColombia = (date = null) => {
  const colombiaDate = date || getNowColombia();
  
  const hours = String(colombiaDate.getHours()).padStart(2, '0');
  const minutes = String(colombiaDate.getMinutes()).padStart(2, '0');
  
  return `${hours}:${minutes}`;
};

/**
 * Formatea fecha completa con hora (Colombia)
 * @param {Date} date - Fecha a formatear (opcional)
 * @returns {string} Fecha y hora formateada
 */
export const getDateTimeColombia = (date = null) => {
  const colombiaDate = date || getNowColombia();
  
  return colombiaDate.toLocaleString('es-CO', {
    timeZone: 'America/Bogota',
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

/**
 * Formatea solo la hora en formato 12h (Colombia)
 * @param {Date} date - Fecha a formatear (opcional)
 * @returns {string} Hora en formato 12h
 */
export const getHora12Colombia = (date = null) => {
  const colombiaDate = date || getNowColombia();
  
  return colombiaDate.toLocaleTimeString('es-CO', {
    timeZone: 'America/Bogota',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  });
};

/**
 * Convierte una fecha ISO string a hora de Colombia
 * @param {string} isoString - Fecha en formato ISO
 * @returns {Date} Fecha convertida a Colombia
 */
export const isoToColombia = (isoString) => {
  const date = new Date(isoString);
  return new Date(date.toLocaleString('en-US', {
    timeZone: 'America/Bogota'
  }));
};
